module.exports = __webpack_public_path__ + "static/media/mushroom.9d8f5888.jpg";